import { useContext } from "react";
import { CarritoContext } from "../context/carritoContext";

export const useCarrito = () => {
  return useContext(CarritoContext);
};
